module.exports = __webpack_public_path__ + "assets/img/smart_red.bfd73f96.png";